import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import {
  getActiveSection,
  getHasResults,
  getIsRootFolder,
  getSelectedFolder,
  getPublishedTiers,
  getStudioParams,
} from '../../../selectors/studio';
import { Props } from './PublishedPageContent';

export type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'selectedFolder'
  | 'hasDeviations'
  | 'isRootFolder'
  | 'tiers'
  | 'contentType'
  | 'tierId'
>;
type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeSection: getActiveSection(state),
  selectedFolder: getSelectedFolder(state),
  hasDeviations: getHasResults(state),
  isRootFolder: getIsRootFolder(state),
  tiers: getPublishedTiers(state),
  contentType: getStudioParams(state).contentType,
  tierId: getStudioParams(state).tierId,
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
